import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import App from "../constants/app";
import Header from "../components/Header";
import { Container, StickyHeader } from "../styled-components/Layout";

const FixedTopBarContainer = styled(StickyHeader)`
  height: ${App.TOP_BAR_HEIGHT};
`;

const FixedTopBar = styled(StickyHeader)``;

class MainLayout extends Component {
  render() {
    return (
      <Container>
        <FixedTopBarContainer>
          <Header path={this.context.router.location.pathname} />
        </FixedTopBarContainer>
        {this.props.children}
      </Container>
    );
  }
}

MainLayout.contextTypes = {
  router: PropTypes.object
};

MainLayout.defaultProps = {
  children: ""
};

MainLayout.propTypes = {
  children: PropTypes.element
};

export default MainLayout;



// WEBPACK FOOTER //
// ./app/layouts/MainLayout.js